import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { gtag } from "../..";
import { useEffect } from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
    useEffect(() => {
        gtag('event', 'page_view', {
            page_title: 'Privacy Policy',
            page_path: '/privacy-policy'
        });
    });
    return (
        <div className="about">
            <Typography component="h1" variant="h1">
                Privacy Policy
            </Typography>
            <Card>
                <CardContent className='summary-content'>
                    <Typography component="p" variant="p">
                        This Privacy Policy describes how poker-scrum.com ("we", "us", or "our") collects, uses, and shares information when you use our website and services. By using Scrum Poker, you agree to the collection and use of information as described in this policy.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Information We Collect
                    </Typography>
                    <Typography component="p" variant="p">
                        <strong>Display Name:</strong> When you create or join a room, you provide a display name. This name is stored temporarily in your browser session and shared with other participants in the same room. It is not permanently stored on our servers.
                    </Typography>
                    <Typography component="p" variant="p">
                        <strong>Usage Data:</strong> We use Google Analytics to collect anonymous usage data such as pages visited, session duration, browser type, and referring URLs. This data helps us understand how our service is used and how to improve it.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Cookies and Advertising
                    </Typography>
                    <Typography component="p" variant="p">
                        We use Google AdSense to display advertisements on our website. Google AdSense uses cookies and similar technologies to serve ads based on your prior visits to this website or other websites. Google's use of advertising cookies enables it and its partners to serve ads to you based on your visit to our site and/or other sites on the Internet.
                    </Typography>
                    <Typography component="p" variant="p">
                        You may opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noreferrer">Google Ads Settings</a>. Alternatively, you may opt out of third-party cookies for personalized advertising by visiting <a href="https://www.aboutads.info/choices/" target="_blank" rel="noreferrer">www.aboutads.info</a>.
                    </Typography>
                    <Typography component="p" variant="p">
                        We also use Google Analytics cookies to understand website traffic and usage patterns. You can learn more about how Google uses data at <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">Google's Privacy & Terms</a>.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        How We Use Information
                    </Typography>
                    <Typography component="p" variant="p">
                        We use the information we collect to: operate and maintain the Scrum Poker service; understand how users interact with our service; display relevant advertisements to support the free service; and improve the user experience.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Data Retention
                    </Typography>
                    <Typography component="p" variant="p">
                        Room data (votes, participant names) is stored temporarily on AWS DynamoDB and is automatically deleted after the session ends. We do not retain personally identifiable information beyond what is necessary for the active session.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Third-Party Services
                    </Typography>
                    <Typography component="p" variant="p">
                        Our service uses the following third-party services that may collect information: Google Analytics (usage analytics), Google AdSense (advertising), and Amazon Web Services (infrastructure). Each of these services has their own privacy policies governing the use of your information.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Children's Privacy
                    </Typography>
                    <Typography component="p" variant="p">
                        Our service is not directed to children under 13. We do not knowingly collect personal information from children under 13.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Changes to This Policy
                    </Typography>
                    <Typography component="p" variant="p">
                        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the date below.
                    </Typography>

                    <Typography component="h2" variant="h2">
                        Contact
                    </Typography>
                    <Typography component="p" variant="p">
                        If you have questions about this Privacy Policy, contact us at <a href="mailto:pokerscrum87@gmail.com">pokerscrum87@gmail.com</a>.
                    </Typography>

                    <Typography component="p" variant="p">
                        This policy was last updated on April 20, 2026.
                    </Typography>
                </CardContent>
            </Card>
        </div>
    );
}

export default PrivacyPolicy;
